// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var UserSettingsController = function ($rootScope, $scope, UserSettings) {
    $scope.languages = $rootScope.getLanguages();
    $scope.userSettings = UserSettings.get();
    $scope.save = function () {
        $scope.userSettings.$update({}, function () {
            $scope.notifySuccess();
            $scope.setLang($scope.userSettings.Culture);
            $scope.languages = $rootScope.getLanguages();
            localStorage.setItem("culture", $scope.userSettings.Culture);
            localStorage.setItem("first_name", $scope.userSettings.FirstName);
            localStorage.setItem("last_name", $scope.userSettings.LastName);
        });
    };

    $scope.isExternalUser = function () {
        return $rootScope.externalUser;
    }

    $scope.isAzureAD = function () {
        return $rootScope.features.AzureActiveDirectory;
    }

    $scope.isOpenId = function () {
        return $rootScope.features.OpenIdConnect;
    }
};
UserSettingsController.$inject = ['$rootScope', '$scope', 'UserSettings'];
